export function parseToLocalDate(dateInput: Date | string | null | undefined): Date | null {
    if (!dateInput) return null;

    if (typeof dateInput === 'string') {
        // Extract year, month, day from the string (ignoring time and timezone)
        const match = dateInput.match(/^(\d{4})-(\d{2})-(\d{2})/);
        if (match) {
            const year = parseInt(match[1], 10);
            const month = parseInt(match[2], 10) - 1; // Month is 0-indexed
            const day = parseInt(match[3], 10);
            return new Date(year, month, day, 0, 0, 0, 0);
        }
    }

    // If it's already a Date object, create a new one with just the date part
    const d = new Date(dateInput);
    return new Date(d.getFullYear(), d.getMonth(), d.getDate(), 0, 0, 0, 0);
}

export function parseToOnlyDateString(dateInput: Date | null | undefined): string | null {
    if (!dateInput) return null;
    return `${dateInput.getFullYear()}-${String(dateInput.getMonth() + 1).padStart(2, '0')}-${String(dateInput.getDate()).padStart(2, '0')}`;
}